import { Action } from '@ngrx/store'
import { ICaption, ICaptionsInfo, ICaptionTranslationLanguages } from '../models'

export const INIT_CAPTION = '[YTCaptions] Init Caption'
export const SELECT_VIDEO = '[YTCaptions] Select Video'
export const SELECT_LANGUAGE = '[YTCaptions] Select Language'
export const LOAD_CAPTION = '[YTCaptions] Load Caption'

export class InitCaption implements Action {
  readonly type = INIT_CAPTION
  constructor() {}
}

export class SelectVideo implements Action {
  readonly type = SELECT_VIDEO
  constructor(public captionsInfo: ICaptionsInfo) {}
}

export class SelectLanguage implements Action {
  readonly type = SELECT_LANGUAGE
  constructor(public languageInfo: ICaptionTranslationLanguages) {}
}

export class LoadCaption implements Action {
  readonly type = LOAD_CAPTION

  constructor(public captions: ICaption[]) {}
}

export type All = InitCaption | SelectVideo | SelectLanguage | LoadCaption



// WEBPACK FOOTER //
// ./src/actions/youtube-captions.ts